import 'vscode/vscode/vs/platform/instantiation/common/extensions';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { AbstractPathService } from '../common/pathService.js';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { firstOrDefault } from 'vscode/vscode/vs/base/common/arrays';
import { dirname } from 'vscode/vscode/vs/base/common/resources';

function guessLocalUserHome(environmentService, contextService) {
    const workspace = contextService.getWorkspace();
    const firstFolder = firstOrDefault(workspace.folders);
    if (firstFolder) {
        return firstFolder.uri;
    }
    if (workspace.configuration) {
        return dirname(workspace.configuration);
    }
    return ( URI.from({
        scheme: AbstractPathService.findDefaultUriScheme(environmentService, contextService),
        authority: environmentService.remoteAuthority,
        path: '/'
    }));
}

export { guessLocalUserHome };
